import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode } from "vue"

import { HEADER } from '@/services/consts';


export default /*@__PURE__*/_defineComponent({
  __name: 'ListHeader',
  setup(__props) {

function headerContentClass(index: number) {
  if (index == 0) {
    return 'ml-2'
  }
  return ''
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("thead", null, [
    _createElementVNode("tr", null, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(HEADER), (item, index) => {
        return (_openBlock(), _createElementBlock("th", {
          key: index,
          class: "table-header column-space id-column"
        }, [
          _createElementVNode("div", {
            class: _normalizeClass(headerContentClass(index))
          }, _toDisplayString(item), 3)
        ]))
      }), 128))
    ])
  ]))
}
}

})